export enum FileCategory {
  Default = 1,
  Signature,
  BookingDocument,
  ProofOfDeliveryDocument,
  StopDocument,
  Photo,
}
